export default class PromiseService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  addPromise(promise) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/promise/add/`, promise);
  }

  updateOwner(promiseId, ownerId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/promise/updateowner/${promiseId}/${ownerId}`);
  }

  complete(promiseId, comments) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/promise/complete`, {promiseId, comments});
  }

}



// WEBPACK FOOTER //
// ./client/app/components/promise/promise.service.js